"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var avatarShape;
(function (avatarShape) {
    avatarShape["CIRCLE"] = "circle";
    avatarShape["SQUARE"] = "square";
    avatarShape["ROUNDED"] = "rounded";
    avatarShape["RECTANGLE"] = "rectangle";
})(avatarShape = exports.avatarShape || (exports.avatarShape = {}));
var avatarType;
(function (avatarType) {
    avatarType["TEXT"] = "text";
    avatarType["IMAGE"] = "image";
    avatarType["ICON"] = "icon";
})(avatarType = exports.avatarType || (exports.avatarType = {}));
var avatarSize;
(function (avatarSize) {
    avatarSize["SMALL"] = "small";
    avatarSize["MEDIUM"] = "medium";
    avatarSize["LARGE"] = "large";
})(avatarSize = exports.avatarSize || (exports.avatarSize = {}));
var avatarFill;
(function (avatarFill) {
    avatarFill["SOLID"] = "solid";
    avatarFill["OUTLINE"] = "outline";
})(avatarFill = exports.avatarFill || (exports.avatarFill = {}));
var avatarThemeColor;
(function (avatarThemeColor) {
    avatarThemeColor["PRIMARY"] = "primary";
    avatarThemeColor["SECONDARY"] = "secondary";
    avatarThemeColor["TERTIARY"] = "tertiary";
    avatarThemeColor["INFO"] = "info";
    avatarThemeColor["SUCCESS"] = "success";
    avatarThemeColor["WARNING"] = "warning";
    avatarThemeColor["ERROR"] = "error";
    avatarThemeColor["DARK"] = "dark";
    avatarThemeColor["LIGHT"] = "light";
    avatarThemeColor["INVERSE"] = "inverse";
    avatarThemeColor["INHERIT"] = "inherit";
})(avatarThemeColor = exports.avatarThemeColor || (exports.avatarThemeColor = {}));
var cardOrientation;
(function (cardOrientation) {
    cardOrientation["HORIZONTAL"] = "horizontal";
    cardOrientation["VERTICAL"] = "vertical";
})(cardOrientation = exports.cardOrientation || (exports.cardOrientation = {}));
var cardType;
(function (cardType) {
    cardType["DEFAULT"] = "default";
    cardType["primary"] = "primary";
    cardType["INFO"] = "info";
    cardType["SUCCESS"] = "success";
    cardType["WARNING"] = "warning";
    cardType["ERROR"] = "error";
})(cardType = exports.cardType || (exports.cardType = {}));
var cardActionsLayout;
(function (cardActionsLayout) {
    cardActionsLayout["START"] = "start";
    cardActionsLayout["CENTER"] = "center";
    cardActionsLayout["END"] = "end";
    cardActionsLayout["STRETCHED"] = "stretched";
})(cardActionsLayout = exports.cardActionsLayout || (exports.cardActionsLayout = {}));
